import React from "react";


const Store = () => {
    const itemsForSale = [
        {
            id: 2, name: "Event Sponsor", price: "$5,000", bullets: ["Company logo on all marketing, social media, and event materials",
                "Presenting Sponsor of entire event",
                "2 Tables at event (16) dinner tickets",
                "2 Red raffle tickets ($500 value each)",
                "1 White raffle ticket ($250 value)",
                "Sponsor Banner",
                "16 Custom Logo Cups"], link: 'https://square.link/u/sPBOXxYN'
        },
        {
            id: 3, name: "Bar Sponsor", price: "$3,500", bullets: ["Company logo on all marketing, social media, and event materials",
                "1 table at event (8) dinner tickets",
                "1 White raffle ticket ($250 value)",
                "Bar sponsor Banner",
                "8 Custom Logo Cups"], link: 'https://square.link/u/pvijJ7IC'
        },
        {
            id: 4, name: "Band Sponsor", price: "$3,500", bullets: ["Company Logo on all marketing, social media, and event materials",
                "1 Table at event (8) Dinner tickets",
                "1 White raffle ticket ($250 value)",
                "Band Sponsor Banner",
                "8 Custom Logo Cups"], link: 'https://square.link/u/BmVORGhQ'
        },
        {
            id: 5, name: "Casino Sponsor", price: "$3,500", bullets: ["Company logo on all marketing, social media, and event materials",
                "1 Table at event (8) dinner tickets",
                "1 White raffle ticket ($250 value)",
                "Casino Sponsor Banner",
                "8 Custom Logo Cups"], link: 'https://square.link/u/QaHashUj'
        },
        {
            id: 6, name: "Catering Sponsor", price: "$3,500", bullets: ["Company logo on all marketing, social media, and event materials",
                "1 Table at event (8) dinner tickets",
                "1 White raffle ticket ($250 value)",
                "Catering Sponsor Banner",
                "8 Custom Logo Cups"], link: 'https://square.link/u/6gi1dqMd'
        },
        {
            id: 7, name: "Scholarship Sponsor", price: "$2,500", bullets: ["Company Logo on scholarship",
                "Scholarship given out in the name designated by you",
                "Scholarship banner"], link: 'https://square.link/u/F7wLnnqj'
        },
        {
            id: 8, name: "Koozie Sponsor", price: "$1,500", bullets: ["Company logo/name on official event koozie",
                "Does Not include admission or dinner tickets"], link: 'https://square.link/u/IwC8DJPv'
        },
        {
            id: 9, name: "Table Sponsor", price: "$600", bullets: ["Company logo on table card",
                "(8) Dinner tickets"], link: 'https://square.link/u/V0pUENIN'
        },
        {
            id: 10, name: "Banner Sponsor", price: "$250", bullets: ["Banner with company logo displayed at event",
                "Does not include admission or dinner tickets"], link: 'https://square.link/u/zlMAU6fi'
        },
        // Add more items as needed
    ];

    return (
        <div className="flex flex-col flex-wrap justify-center pt-[150px] pb-[300px] bg-white mx-auto w-1/2 max-md:w-[80%] max-md:p-0">
            <h1>Purchase Tickets</h1>
            <ul className="list-none p-0 m-0">
                <li className="mb-5 p-5 rounded-xl bg-[#e4e4f1] flex flex-row items-start justify-between flex flex-row border-gray-300 border-[1px]">
                    <div className="flex flex-col items-start" >
                        <h3 className="font-bold">Individual Ticket</h3>
                        <p>A ticket to admit one person</p>
                    </div>
                    <button onClick={() => window.location.href = 'https://square.link/u/7aVegTGK'} className="bg-[#007aff] text-white px-5 py-2.5 border-none cursor-pointer items-center appearance-none rounded-[10px] box-border inline-flex h-[48px] w-[150px] justify-center leading-none list-none overflow-hidden relative text-left no-underline transition-all duration-150 select-none touch-manipulation whitespace-nowrap text-[18px] m-[5px] ml-auto"><p className="text-white font-bold text-[0.8em]"> $100</p></button>
                </li>
                <div style={{ height: '100px' }}></div>
                {itemsForSale.map(item => (
                    <li key={item.id} className="mb-5 p-5 rounded-xl bg-[#e4e4f1] flex flex-row items-start justify-between border-gray-300 border-[1px]">
                        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left', width: '100%' }}>
                            <div style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <h3 className="font-bold">{item.name}</h3>
                                <button onClick={() => window.location.href = item.link} className="bg-[#007aff] text-white px-5 py-2.5 border-none cursor-pointer items-center appearance-none rounded-[10px] box-border inline-flex h-[48px] w-[150px] justify-center leading-none list-none overflow-hidden relative text-left no-underline transition-all duration-150 select-none touch-manipulation whitespace-nowrap text-[18px] m-[5px] ml-auto"><p className="text-white font-bold text-[0.8em]">{item.price}</p></button>
                            </div>
                            <ul>
                                {item.bullets.map((bullet, index) => (
                                    <li className="flex items-center" key={index}><div className="w-1 h-1 bg-black rounded-full mr-2" />{bullet}</li>
                                ))}
                            </ul>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Store;
